import {
  // APIAuthenticateSSO,
  APIRegisterEmailVerificationSSO,
  APIRegisterCodeVerificationSSO,
  APIRegisterNormal,
  APIForgotPasword,
  APICodeVerificationSSO,
  APIResetPasswordSSO,
  // APIUpdateProfileSSO,
  APIUpdateProfileSSO,
  APIUpdateTenantByUserSSO,
  APIChangePasswordSSO,
  APIGetUserDetailsSSO
  // APIUpdatePasswordSSO,
  // APIInviteCodeVerificationSSO,
  // APIRegisterInvited,
  // APIRegisterInviteUserSSO,
  // APISignoutSSO,
  // APIUpdateLangSSO
} from '../api/authSSO.ts';
//same for resnd also
export async function registerEmailVerificationSSO(email) {
    const { response } = await APIRegisterEmailVerificationSSO({
      email
    });
    return response;
}

export async function registerCodeVerificationSSO(code: any) {
  const { status } = await APIRegisterCodeVerificationSSO({
    code
  });
  console.log('status',status)
  if (status?.toString() !== '200') {
    throw new Error();
  }
  return status;
}

export async function registerNormal(params){
  console.log('before params',params)
    const response =  await APIRegisterNormal(params);
    console.log('response',response);
    // { authentication, email, profile, role, tenant, ...rest }
    return response;
} 

export async function forgetPassword(email: string) {
    const response = await APIForgotPasword({ body: { email } });
    return response;
}

export async function codeVerificationSSO(code) 
{
  try {
  const { status } = await APICodeVerificationSSO({
    code
  });
  if (status?.toString() !== '200') {
    throw new Error();
  }
  return status;
} catch (err) {
  const errMsg = err.response.data.message;
  return errMsg;
}
}

export async function resetPassword(verificationCode: string, newPassword: string) {
  try {
   
    await APIResetPasswordSSO(verificationCode, newPassword);
    return "200";
  } catch (err) {
    const errMsg = err.response.data.message;
    return errMsg;
  }
}
export async function changePasswordSSO( data) {
  try
  {
    console.log('data',data);
    
    const { response, status } = await APIChangePasswordSSO({
      data: data
    });
    console.log('response',response);
    if (status?.toString() !== '200') {
      return "Unable to change password.";
    }
    return response;
  }
  catch (err) {
    const errMsg = err.response.data.message;
    return errMsg;
  }
}


export async function updateProfile( data) {
  try
  {
    console.log('updateProfile',data);
    
    const { response, status } = await APIUpdateProfileSSO({
      data: data
    });
    console.log('response',response);
    if (status?.toString() !== '200') {
      
      return "Unable to update.";
    }
    return response;
  }
  catch (err) {
    const errMsg = err.response.data.message;
    return errMsg;
  }
}
export async function updateTenantByUser( data) {
  try
  {
    console.log('updateTenantByUser',data);
    
    const { response, status } = await APIUpdateTenantByUserSSO({
      data: data
    });
    console.log('response',response);
    if (status?.toString() !== '200') {
      
      return "Unable to update.";
    }
    return response;
  }
  catch (err) {
    const errMsg = err.response.data.message;
    return errMsg;
  }
}
export async function getUserSSO() {
  const res = await APIGetUserDetailsSSO({});
//res?.response?.userDetails?.tenant?.config;
  console.log('res',res);
  return res;
 
}
// export async function setPassword(req: SetPasswordRequest) {
  
//     await this.client.post('/console/customers/set-password', req);
// }